import {
    getLastestMsg,
    handleMsg
} from 'api/tripNotify'
import { LandingPageMap } from 'data/notification'
const noAlertMsgsTypes = [];
const pageMsgsTypes = {
    65: {
        pathRegs: [/#\/jiujing\/$/, /#\/jiujing\/product\/list/]
    }
};


class ToastAndAlertNotification {

    constructor(Modal, Notice, router) {
        this.Modal = Modal
        this.Notice = Notice
        this.STRONGWEIGHT = 3
        this.MIDDLEWEIGHT = 2
        this.hasStrongMsg = false
        this.hasMiddleMsg = false
        this.unreadChanged = false
        this.showingStrongMsg = false
        this.showingMiddleToast = false
        this.router = router
    }

    async onUnreadChange(map) {
        if (this.unreadChanged) {
            return
        }
        if (this.showingStrongMsg) {
            return
        }
        this.unreadChanged = true;
        let msgs = [];
        Object.keys(map).forEach((categoryId) => {
            msgs = msgs.concat(map[categoryId] || []);
        });
        for (let i = 0; i < msgs.length; ++i) {
            let msg = msgs[i];
            if (msg.typeWeight === this.STRONGWEIGHT) {
                this.hasStrongMsg = true;
                break;
            }
            if (msg.typeWeight === this.MIDDLEWEIGHT) {
                this.hasMiddleMsg = true;
            }
            if (this.hasStrongMsg || this.hasMiddleMsg) {
                try {
                    const lastData = await getLastestMsg(this.hasStrongMsg ? 3 : 2)
                    const latestMsgs = lastData && lastData.data || [];
                    if (latestMsgs.length) {
                        let strongMsg = latestMsgs.find((msg) => {
                            return msg.typeWeight === this.STRONGWEIGHT;
                        })
                        let msgType = strongMsg && strongMsg.msgInfo && strongMsg.msgInfo.typeId || null;
                        if (noAlertMsgsTypes.indexOf(msgType) !== -1) {
                            return;
                        }
                        let msgPageConfig = pageMsgsTypes[msgType];
                        if (msgPageConfig) {
                            let pageRegs = msgPageConfig.pathRegs || [];
                            let hash = window.location.hash;
                            let isMsgPage = pageRegs.find((reg) => {
                                return reg.test(hash);
                            }) ? true : false;
                            if (!isMsgPage) {
                                return;
                            }
                        }
                        if (strongMsg && !this.showingStrongMsg) {
                            this.showingStrongMsg = true;
                            this.showStrongAlert(strongMsg.msgInfo.typeDesc, strongMsg.msgInfo.msgBody, this.getBtnTextByMessage(strongMsg.msgInfo), () => {
                                let msgId = strongMsg.msgInfo.broadCastId;
                                if (!this.ignoreMarkAsRead(strongMsg)) {
                                    handleMsg(msgId);
                                }
                                this.processMsg(strongMsg)
                                this.showingStrongMsg = false;
                                setTimeout(() => this.showMiddleToastMsg(latestMsgs), 10000)
                            })
                        } else {
                            this.showMiddleToastMsg(latestMsgs)
                        }
                    }
                } catch (e) {
                    console.log(e)
                }
            }
        }
    }

    showMiddleToastMsg(latestMsgs) {
        if (this.showingMiddleToast) {
            return
        }
        let middleMsg = latestMsgs.find((msg) => {
            return msg.typeWeight === this.MIDDLEWEIGHT
        })
        if (middleMsg && !this.showingMiddleToast) {
            this.showingMiddleToast = true;
            let msgId = middleMsg && middleMsg.msgInfo && middleMsg.msgInfo.broadCastId || null;
            this.showMiddleToast(middleMsg.msgInfo.typeDesc, middleMsg.msgInfo.msgBody, this.getBtnTextByMessage(middleMsg.msgInfo), msgId, () => {
                this.showingMiddleToast = false;
                if (!this.ignoreMarkAsRead(middleMsg)) {
                    handleMsg(msgId);
                }
                this.processMsg(middleMsg);
                this.showingMiddleToast = false;
                this.Notice.close(msgId)
            });
        }
    }

    showMiddleToast(title, msg, btnText, name, okCallBack) {
        this.Notice.warning({
            duration: 0,
            name,
            title,
            render: h => {
                return h('div', [
                    h('div', [
                        msg
                    ]),
                    h('div', [
                        h('Button', {
                            style: {
                                float: 'right',
                                marginTop: '10px'
                            },
                            props: {
                                type: 'info'
                            },
                            on: {
                                click: okCallBack
                            }
                        }, [
                            btnText
                        ])
                    ])
                ])
            }
        })
    }

    showStrongAlert(title, msg, btnText, okCallBack) {
        this.Modal.warning({
            title,
            content: msg,
            okText: btnText || '去处理',
            closable: true,
            onOk: okCallBack,
        })
    }

    getBtnTextByMessage(msg) {
        const landPageInfo = LandingPageMap[msg.typeId || msg.msgTypeId];
        return landPageInfo ? '去处理' : '已联系BD';
    }
    processMsg(msg) {
        if (msg.msgInfo && msg.msgInfo.typeId) {
            let landPageInfo = LandingPageMap[msg.msgInfo.typeId + 'taa'] || LandingPageMap[msg.msgInfo.typeId];
            if (landPageInfo.urlPattern) {
                window.open(
                    landPageInfo.urlPattern.replace("$bizKey", msg.msgInfo.bizKey),
                    "_blank"
                );
                return;
            }
            if (landPageInfo) {
                let params = {};
                if (landPageInfo.paramName) {
                    params[landPageInfo.paramName] = msg.msgInfo.bizKey;
                }
                if (landPageInfo.paramsExt) {
                    params = Object.assign(landPageInfo.paramsExt, params);
                }
                if (landPageInfo.query) {
                    query = Object.assign({}, landPageInfo.query);
                }
                this.router.push({ name: landPageInfo.stateName, query: params, params })
            }
        }
    }

    ignoreMarkAsRead(msg) {
        if (msg && msg.msgInfo && msg.msgInfo.typeId === 65) {
            return true;
        }
        return false;
    }
}

export default ToastAndAlertNotification


// WEBPACK FOOTER //
// ./src/components/message/toastAndAlertNotification.js